export const EVENTS = {
    SHOW_CODE_ACTIVATION_MODAL: 'show_code_activation_modal',
    REGISTER_CODE_ACTIVATION_LISTENER: 'register_code_activation_listener',
} as const;

export const EMITTER_TIMEOUT = 10 * 1000;
